import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FiHome,
  FiSearch,
  FiMessageCircle,
  FiHeart,
  FiUser,
  FiLogOut,
} from "react-icons/fi";
import LoginModal from "./LoginModal";

function BottomMenu() {
  const navigate = useNavigate();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [showLogin, setShowLogin] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  useEffect(() => {
    const handleStorageChange = () => {
      setToken(localStorage.getItem("token"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const logoutNow = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    localStorage.removeItem("useremail");
    setToken(null);
    setShowLogoutConfirm(false);
    navigate("/");
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      {/* BOTTOM NAVIGATION */}
      <div className="bottom-menu ">
        <Link to="/my-soulsathi" className={`menu-item ${isActive("/my-soulsathi") ? "active" : ""}`}>
          <FiHome />
          <span>Home</span>
        </Link>

        <Link
          to="/search"
          className={`menu-item ${isActive("/search") ? "active" : ""}`}
        >
          <FiSearch />
          <span>Search</span>
        </Link>

        <Link
          to="/chats"
          className={`menu-item ${isActive("/chats") ? "active" : ""}`}
        >
          <FiMessageCircle />
          <span>Messages</span>
        </Link>
 
        {/* ACCOUNT / LOGIN BUTTON */}
        {token ? (
          <div
            className={`menu-item ${isActive("/my-profile") ? "active" : ""}`}
            onClick={() => navigate("/my-profile")}
          >
            <FiUser />
            <span>Account</span>
          </div>
        ) : (
          <div className="menu-item" onClick={() => setShowLogin(true)}>
            <FiUser />
            <span>Login</span>
          </div>
        )}
      </div>

      {/* LOGIN POPUP */}
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}

      {/* LOGOUT CONFIRMATION MODAL */}
      {showLogoutConfirm && (
        <div className="logout-modal">
          <div className="modal-box">
            <p>Are you sure you want to logout?</p>
            <button onClick={logoutNow} className="confirm-btn">
              Logout
            </button>
            <button
              onClick={() => setShowLogoutConfirm(false)}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default BottomMenu;
